import { Paper, styled, Switch, Typography, useMediaQuery } from '@mui/material'
import Grid from '@mui/material/Grid2'
import Stack from '@mui/material/Stack'
import { filter, get, map } from 'lodash'
import { useEffect, useState } from 'react'
import { useProfileStore } from '../../../../store/storeProfile'
import { theme } from '../../../../theme'
import { StorageCard } from './StorageCard'

const ReferralBlockWrapper = styled(Paper)(() => ({
    marginBottom: '16px',
    backgroundColor: '#fff',
    ...theme.applyStyles('dark', {
        backgroundColor: '#1A2027',
    }),
    padding: '24px',
    height: '100%',
    border: '1px solid #E9EAED',
    [theme.breakpoints.down('md')]: {
        padding: '12px',
    },
}))

export const Storage = () => {
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    const { storageTariffs, storageTariffUser } = useProfileStore((state) => state)
    const [isYearStoragePeriod, setYearStoragePeriod] = useState(false)

    const handelChangeEnabled = (event) => {
        setYearStoragePeriod(event.target.checked)
    }

    useEffect(() => {
        const data = filter(filter(storageTariffUser, { is_active: true }), function (tariff) {
            return get(tariff, 'storage_tariff.period') === 'YEAR'
        })
        if (data.length > 0) {
            setYearStoragePeriod(true)
        }
    }, [storageTariffUser])

    return (
        <ReferralBlockWrapper>
            <Stack direction={isMobile ? 'column' : 'row'} sx={{ alignItems: 'baseline' }}>
                <Typography
                    sx={{
                        marginBottom: '12px',
                        color: '#000',
                    }}
                    variant="h3">
                    Выбери объем диска
                </Typography>

                <Stack
                    direction="row"
                    sx={{ justifyContent: 'space-between', margin: isMobile ? 0 : 'auto' }}
                    spacing={1}>
                    <Typography
                        variant={isYearStoragePeriod ? 'body2' : 'h6'}
                        color={isYearStoragePeriod ? '#5A5F72' : '#1B1C1D'}>
                        На месяц
                    </Typography>
                    <Switch
                        size="small"
                        checked={isYearStoragePeriod}
                        onChange={handelChangeEnabled}
                    />
                    <Typography
                        variant={isYearStoragePeriod ? 'h6' : 'body2'}
                        color={isYearStoragePeriod ? '#1B1C1D' : '#5A5F72'}>
                        На год{' '}
                    </Typography>

                    <Typography variant="h6" sx={{ color: '#006AD8' }}>
                        (выгоднее на 20%)
                    </Typography>
                </Stack>
            </Stack>

            <Grid
                mt={3}
                container
                spacing={isMobile ? 1 : 0}
                sx={{ width: '100%', display: 'flex' }}
                color="primary">
                {map(
                    filter(storageTariffs, { period: isYearStoragePeriod ? 'YEAR' : 'MONTH' }),
                    (item, index) => {
                        if (item.name === 'Базовый' || item.name === 'Гостевой') {
                            return
                        }
                        const active = filter(storageTariffUser, { tariff_id: item.id })
                        const isHasPeriod = filter(storageTariffUser, function (tariff) {
                            return get(tariff, 'storage_tariff.period') === item.period
                        })
                        return (
                            <StorageCard
                                item={item}
                                index={index}
                                active={active ? active[0] : undefined}
                                isHasPeriod={isHasPeriod?.length ? true : false}
                            />
                        )
                    },
                )}
            </Grid>
        </ReferralBlockWrapper>
    )
}
